import Banner from "@/components/landing/helpCenterDetails/Banner";
import CreateAccount from "@/components/landing/helpCenterDetails/CreateAccount";
import NeedToContact from "@/components/landing/helpCenterDetails/NeedToContact";

export default function HelpCenterDetails() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Create Account section */}
      <CreateAccount />

      {/* Need To Contact section */}
      <NeedToContact />
    </>
  );
}
